import { useEffect } from "react";
import { socket } from "./socketIO";
import { useSelector, useDispatch } from "react-redux";

const SocketUpdate = () => {
  const user = useSelector((state) => state.loggedUser.user);
  const dispatch = useDispatch();

  useEffect(() => {
    // "";
  }, [user]);

  useEffect(() => {
    if (!user?.id) return; // No user, skip

    const handleConnect = () => {
      // Register user once connected
      socket.emit("register", user.id);

      // // Optional reconnect logic
      // setTimeout(() => {
      //   if (socket.connected) {
      //     "";
      //     socket.disconnect();
      //     socket.connect();
      //   }
      // }, 1000 * 60 * 30);
    };

    const handleNotification = (data) => {
      dispatch({ type: "SET_USER_NOTIFCATION", payload: data });
    };

    // Attach listeners
    socket.on("connect", handleConnect);
    socket.on("notification", handleNotification);

    //  If already connected (like on login page), register immediately
    if (socket.connected) {
      handleConnect();
    } else {
      socket.connect();
    }

    // Cleanup
    return () => {
      socket.off("connect", handleConnect);
      socket.off("notification", handleNotification);
      // ⚠️ Don’t disconnect globally unless you manage socket only here
      // socket.disconnect();
    };
  }, [user?.id]);



  return null;
};

export default SocketUpdate;
